import * as React from "react";

export class CustomTable extends React.Component<{ children?: any; isEnabled?: (id: string) => boolean; className?: string }, {}> {


    isEnabled(id: string): boolean {
        return this.props.isEnabled(id);
    }

    renderChildren(elements: React.ReactChildren) {
        if (!elements) {
            return [];
        }

        return React.Children.map(elements, (child: React.ReactElement<any>) => {
            if (typeof child == "undefined" || child == null) {
                return child;
            }
            if (child.type == "th" || child.type == "td") {
                // console.log("Found th,td = ", child.props);
                if (!child.props["data-id"] || this.isEnabled(child.props["data-id"])) {
                    return React.cloneElement(child, child.props, this.renderChildren(child.props ? child.props.children : undefined));
                } else {
                    return false;
                }
            } else if (typeof child.type == "string") {
                return React.cloneElement(child, child.props, this.renderChildren(child.props ? child.props.children : undefined));
            }
            return child;
        })
    }

    render() {
        return (
            <table className={this.props.className}>
                {this.renderChildren(this.props.children)}
            </table>
        )
    }
}


// WEBPACK FOOTER //
// ./src/app/ui/util/CustimizableTable.tsx